export default __webpack_public_path__ + "171566b6b6925e3de44554278b5e2ecb.png";